export default "__VITE_ASSET__Br_adEGx__"